//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import Moment from 'moment';
import config from '../../config';
//import compose from 'recompose/compose';
//-- Custom
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { tagsActions, alertActions, userActions } from '../../_actions';
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    }
});


class Tags extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            perPageData: 10,
            getTagsList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            tags: {
                name: '',
            },
            addButton: false,
            addTag: false,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the tags data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        dispatch(tagsActions.getTagsList(apiConstants.GET_TAGS_LIST, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { siteConstants } = props.language;
        const { dispatch } = this.props;

        if (this.props.deleteTag.deleteTag !== undefined && this.props.deleteTag.deleteTag !== false) {
            if (this.state.triggerDelete === true) {
                dispatch(alertActions.success(siteConstants.GEN_TAG_DELETED_NOTIFICATION));
                this.setState({ enableDelete: false, deleteTagId: '', triggerDelete: false });
                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);

            }
        }
        //when tag saved
        if (props.addTag && props.addTag.addTag !== false) {
            if (this.state.triggeraddTag === true) {
                dispatch(alertActions.success(siteConstants.GEN_TAG_ADDED_NOTIFICATION));
                this.setState({ addTag: !this.state.addTag, triggeraddTag: false });
                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);
            }
        }


        if (props.getTagsList) {
            if (props.getTagsList.getTagsList) {
                if (props.getTagsList.getTagsList.data && props.getTagsList.getTagsList.pagination !== undefined) {
                    this.setState({
                        totalPage: props.getTagsList.getTagsList.pagination.totalPages,
                        totalDataCount: props.getTagsList.getTagsList.pagination.totalCount,
                        getTagsList: props.getTagsList.getTagsList.data,
                        currentPage: props.getTagsList.getTagsList.pagination.currentPage,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        dispatch(tagsActions.getTagsList(apiConstants.GET_TAGS_LIST, postData));
    }

    /*
    * searchTags - User can search data from the database and it will appear
    */
    searchTags(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        if (this.state.perPageData !== 10)
            this.setState({ perPageData: 10 });

        if (keyword.target.value !== '') {
            postData.qwery = keyword.target.value;
            dispatch(tagsActions.getTagsList(apiConstants.SEARCH_TAGS, postData));
        } else {
            dispatch(tagsActions.getTagsList(apiConstants.GET_TAGS_LIST, postData));
        }



    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = () => {
        this.setState({
            addTag: !this.state.addTag,
            tagAddSuccess: '',
            addTagTitle: '',
            triggeraddTag: false
        });

    };

    //close the add tag popup
    closeAddTagPop = () => {
        this.setState({
            addTag: !this.state.addTag,
            tagAddSuccess: '',
            tagAddError: '',
            addTagTitle: '',
            triggeraddTag: false
        });
    }

    //handle submit of add tag popup
    handleSubmitAddTag = () => {
        const { siteConstants } = this.props.language;
        const { addTagTitle } = this.state;
        this.setState({ tagAddError: '' })
        if (addTagTitle === undefined || addTagTitle === '') {
            this.setState({ tagAddError: siteConstants.LABEL_TAG_TITLE_REQUIRED });
        } else {
            this.setState({ triggeraddTag: true })
            let postData = {};
            postData.page = 1;
            postData.orderBy = "id";
            postData.orderByAscDesc = "ASC";
            postData.perPage = this.state.perPageData;

            const obj = {};
            obj.tagTitle = addTagTitle;
            this.props.dispatch(tagsActions.addTag(apiConstants.SAVE_TAG, obj, apiConstants.GET_TAGS_LIST, postData));
        }
    }

    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            tags: {
                name: '',
            },
            addButton: false,
            [type]: false
        });
    };

    /*
    *   Page Limit handle
    */
    handlePageLimitChange = (e) => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPageData = parseInt(e.target.value);

        this.setState({ perPageData: parseInt(e.target.value) });
        dispatch(userActions.getUsersList(apiConstants.GET_TAGS_LIST, postData));
    }

    /*
    *   We are handling validation from this function
    */
    handleValidation(data) {
        const { siteConstants } = this.props.language;
        let fields = data.defaultData;
        let errors = {};
        let formIsValid = true;
        //Name
        if ((fields["name"] == '')) {
            formIsValid = false;
            if (fields["name"] == '')
                errors["name"] = siteConstants.ERR_CAN_NOT_BLANK;
        }

        return ({ errors, formIsValid });
    }

    /*
    *   Tags can add/edit from this area
    */
    tagsAddUpdate = (e, data) => {
        e.preventDefault();

        if (this.handleValidation(data).formIsValid) {
            let postData = {};
            postData.page = 1;
            postData.orderBy = "id";
            postData.orderByAscDesc = "ASC";

            this.props.dispatch(tagsActions.addUpdateTag(apiConstants.ADD_UPDATE_TAGS, data.defaultData, apiConstants.GET_TAGS_LIST, postData));
            this.popupClose('editOpen');

            return ({ errors: {}, formIsValid: true });
        } else {
            return this.handleValidation(data);
        }
    }

    /*
        we can remove the selected data, using the below function
    */
    deleteTagNow = () => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        this.setState({
            triggerDelete: true
        })

        let obj = {};
        obj.id = this.state.deleteTagId;
        this.props.dispatch(tagsActions.deleteTag(apiConstants.DELETE_TAG, obj, apiConstants.GET_TAGS_LIST, postData));
    }


    //on change tag title
    onChangeTagTitle = (e) => {
        this.setState({ addTagTitle: e.target.value })
    }

    // delete a tag by tagId
    deleteTag = (tagId) => {
        this.setState({
            enableDelete: true,
            deleteTagId: tagId
        })
    }

    closeDeletePopup = () => {
        this.setState({
            enableDelete: false,
            deleteTagId: ''
        })
    }


    //-- Main function
    render() {

        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_TAGS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_TAGS}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.popupOpen()}>
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>
                            </div>

                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.handlePageLimitChange(e)} perPageData={this.state.perPageData} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" palaceholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" placeholder="" aria-controls="dataTable" onChange={(e) => this.searchTags(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="10%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col">{siteConstants.GEN_NAME}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getTagsList != undefined && this.state.getTagsList.length > 0 ? this.state.getTagsList.map((tags, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index + 1}</td>
                                                                <td>{tags.title}</td>
                                                                <td className="tdTextCenter">
                                                                    <a className="actionIcon" title="Delete" href="javascript:void(0)" onClick={() => this.deleteTag(tags._id)}><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) : <tr>
                                                        <td colSpan="3">{siteConstants.GEN_NO_RECORD}</td>
                                                    </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* add tag popup */}
                <Dialog
                    open={this.state.addTag}
                    aria-labelledby="tag-popup-title"
                    aria-describedby="save-tagpopup"
                >
                    <DialogTitle id="tag-title" className={classes.root}>{siteConstants.LABEL_ADD_TAGS}</DialogTitle>
                    <DialogContent className={classes.contentRoot}>
                        <div class="row">
                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_NEW_TAG_FIELD}</label>
                                    <input
                                        type="text"
                                        onChange={(e) => this.onChangeTagTitle(e)}
                                        placeholder={siteConstants.LABEL_NEW_TAG_FIELD}
                                        className="form-control"
                                    />
                                    <p style={{ color: 'red' }}>{this.state.tagAddError}</p>
                                    {/* <p style={{ color: 'green' }}>{this.state.categorySuccess}</p>                                        */}
                                </div>
                            </div>
                        </div>
                    </DialogContent>


                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitAddTag(e)}>{siteConstants.LABEL_SAVE}</Button>
                        <Button variant="contained" onClick={() => this.closeAddTagPop()}>{siteConstants.LABEL_CANCEL}</Button>
                    </DialogActions>
                </Dialog>

                {/* notify about delete */}
                <Dialog open={this.state.enableDelete} aria-labelledby="delete-tag-notify" >
                    <DialogTitle className={classes.root}>
                        {siteConstants.BTN_DELETE}
                    </DialogTitle>
                    <DialogContent>
                        {siteConstants.GEN_ARE_SURE_TO_DELETE_TAG}
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={(e) => this.deleteTagNow(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                        <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getTagsList, language, addTag, deleteTag } = state;
    return {
        getTagsList,
        language,
        addTag,
        deleteTag
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Tags));
